import React, { useState, useEffect } from "react";
import FETCH from "../../../../utils/fetch";
import MODULE_API from "../../../../apis/module.api";
import { useHistory } from "react-router-dom";
import Loader from "../../../styled-components/loader/loader";

import "../style/debtDetails.css";
import moment from "moment";

export const DebtTransactionList = (props) => {
  const [loading, setLoading] = useState(false);
  // console.log("props in trancasct", props);
  const [liabilitiesCredit, setLiabilitesCredit] = useState([]);
  const history = useHistory();

  const getLiabilitesList = async () => {
    try {
      (async () => {
        setLoading(true);
        if (props.data === undefined) {
          history.push("/debtPayOff");
        } else {
          let datares = await MODULE_API.getTransactionsData(props.data.id);
          setLoading(false);

          if (datares && datares.data && datares.data.rows) {
            setLiabilitesCredit(datares.data.rows);
          }
        }
      })();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("calling api");
    getLiabilitesList();
  }, []);

  return (
    <div>
      {" "}
      <div className="cardHeadingDebt">Transactions</div>
      <div className="listingContainer1">
        <React.Fragment>
          {liabilitiesCredit && liabilitiesCredit.length > 0 ? (
            liabilitiesCredit.map((item, index) => (
              <div key={index} className="list-row-noBg">
                <div className="listname-dark">
                  <div>
                    {item.created_at &&
                      moment(item.created_at).format("MM-DD-YYYY")}
                  </div>
                  <div style={{ color: "#26C0E2", fontWeight: "400" }}>
                    ${item.amount && item.amount.toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </div>
                </div>
                <div className="listStatus">{item.status}</div>
              </div>
            ))
          ) : (
            <div className="nodata">No Data to Show</div>
          )}
        </React.Fragment>
      </div>
      <Loader isLoading={loading} />
    </div>
  );
};
